import React from "react";
import styled from "styled-components";
import { BigPlusButton } from "@ui/components/buttons/bigPlusButton";
import { BoldButton } from "@ui/components/buttons/boldButton";
import { Button, ButtonSize, ButtonVariant } from "@ui/components/buttons/button";
import { DefaultButton } from "@ui/components/buttons/defaultButton";
import { DeleteButton } from "@ui/components/buttons/deleteButton";
import { EditButton } from "@ui/components/buttons/editButton";
import { LoadingButton } from "@ui/components/buttons/loadingButton";
import { NextButton } from "@ui/components/buttons/nextButton";
import { PrimaryButton, SecondaryTouchButton } from "@ui/components/buttons/primaryButton";
import { RoundedPlusButton } from "@ui/components/buttons/roundedPlusButton";
import { SecondaryButton } from "@ui/components/buttons/secondaryButton";
import { TertiaryButton } from "@ui/components/buttons/tertiaryButton";
import { ThirdaryButton } from "@ui/components/buttons/thirdaryButton";
import { Card, CardTitle, Caption, Row, Section, SectionIntro, SectionTitle, Stack } from "./debugUi";

const variants: ButtonVariant[] = ["primary", "outline", "ghost", "white", "social"];
const sizes: ButtonSize[] = ["sm", "md", "lg"];
const loadingTypes = ["primary", "secondary", "default", "thirded"] as const;

export const ButtonsSection: React.FC = () => {
	return (
		<Section id="buttons">
			<SectionTitle>Boutons</SectionTitle>
			<SectionIntro>Button (nouveau) et la famille DefaultButton.</SectionIntro>

			<Card>
				<CardTitle>Button</CardTitle>
				{sizes.map((size) => (
					<Row key={size}>
						<Caption>{size}</Caption>
						{variants
							.filter((variant) => variant !== "social")
							.map((variant) => (
								<Button key={variant} variant={variant} size={size}>
									{variant}
								</Button>
							))}
					</Row>
				))}
				<Stack>
					<Caption>social</Caption>
					<Button variant="social">Continuer</Button>
				</Stack>
				<Row>
					<Button loading>Chargement</Button>
					<Button variant="outline" loading>
						Chargement
					</Button>
					<Button disabled>Désactivé</Button>
					<Button variant="ghost" disabled>
						Désactivé
					</Button>
				</Row>
				<BlockWrap>
					<Button block>Pleine largeur</Button>
				</BlockWrap>
			</Card>

			<Card>
				<CardTitle>DefaultButton</CardTitle>
				<Row>
					<DefaultButton>Défaut</DefaultButton>
					<DefaultButton light>Light</DefaultButton>
					<DefaultButton lighter>Lighter</DefaultButton>
					<DefaultButton disabled>Désactivé</DefaultButton>
				</Row>
			</Card>

			<Card>
				<CardTitle>Variantes</CardTitle>
				<Row>
					<PrimaryButton>Primary</PrimaryButton>
					<SecondaryTouchButton>Secondary touch</SecondaryTouchButton>
					<SecondaryButton>Secondary</SecondaryButton>
					<ThirdaryButton>Thirdary</ThirdaryButton>
					<TertiaryButton>Tertiary</TertiaryButton>
					<BoldButton>Bold</BoldButton>
				</Row>
				<Row>
					<PrimaryButton disabled>Primary off</PrimaryButton>
					<SecondaryButton disabled>Secondary off</SecondaryButton>
					<TertiaryButton disabled>Tertiary off</TertiaryButton>
				</Row>
			</Card>

			<Card>
				<CardTitle>LoadingButton</CardTitle>
				{loadingTypes.map((buttonType) => (
					<Row key={buttonType}>
						<LoadingButton buttonType={buttonType}>{buttonType}</LoadingButton>
						<LoadingButton buttonType={buttonType} loading>
							{buttonType}
						</LoadingButton>
					</Row>
				))}
			</Card>

			<Card>
				<CardTitle>Actions</CardTitle>
				<Row>
					<NextButton />
					<EditButton onClick={() => undefined} />
					<DeleteButton onClick={() => undefined} />
					<BigPlusButton label="Ajouter" />
					<RoundedPlusButton />
					<RoundedPlusButton inverted />
					<RoundedPlusButton hideLabel />
					<RoundedPlusButton loading />
				</Row>
			</Card>
		</Section>
	);
};

const BlockWrap = styled.div`
	max-width: 360px;
`;
